export const WS_COMMANDS = {
  PING: "treatment.ping",
  PONG: "treatment.pong",
  LIVE_CHECK_REQ: "treatment.livecheck",
  LIVE_CHECK_RESPONSE: "treatment.live",
  TREATMENT_CLEAR: "treatment.clear",
  HI: "treatment.hi",
  BYE: "treatment.bye",
  WELCOME_STUDENT_VIDEO_STATS: "treatment.welcomeStudentVideoStats",
  STUDENT_CURRENT_STATUS: "treatment.studentCurrentStatus",
  IS_TEACHER_CONNECTED: "treatment.isTeacherConnected",
  SESSION_COMPLETED: "treatment.sessionCompleted",
  
  // control student
  KICK_FROM_SESSION: "treatment.kick",

  //content
  SET_STUDENT_BOARD: "treatment.setStudentBoardMode",
  TOGGLE_LOCK_TO_STUDENT: "treatment.toggleStudentLock",
  SET_IS_LOCKED: "treatment.setIsLocked",
  SET_TEACHER_PRESENTING: "treatment.setIsTeacherPresenting",
  SET_PREVIEW_MODE: "treatment.setPreviewMode",
  SET_PREVIEW_STUDIO_ACTVITY: "treatment.setPreviewStudioActivity",
  SET_PREVIEW_H5P_GAME: "treatment.setPreviewH5PGame",

  PRESENT_DRAWING_TO_STUDENT: "drawing.present",
  CLOSE_DRAWING_TO_STUDENT: "drawing.close",

  // game timer
  SET_GAME_TIMER_START: "game.timer.start",
  SET_GAME_TIMER_STOP: "game.timer.stop",
  SET_GAME_SW_START: "game.stopwatch.start",
  SET_GAME_SW_PAUSE: "game.stopwatch.pause",
  SET_GAME_SW_STOP: "game.stopwatch.stop",
  SET_GAME_TIME_SYNC: "game.time.sync",

  //studio
  SET_STUDENT_ACTIVITY: "treatment.setStudentStudioActivity",
  SET_H5P_GAME: "treatment.setH5PGame",
  SET_IS_H5P_GAME_DONE: "treatment.setIsH5PGameDone",
  SET_IS_PREVIEW_H5P_GAME_DONE: "treatment.setIsPreviewH5PGameDone",
  STUDENT_STUDIO_ACTIVITY_UPDATE: "activity.update",

  //articulation
  SEND_ARTICULATION_WORD: "treatment.articulationWord",
  SEND_ARTICULATION_RESULT: "treatment.articulationResult",
  SEND_IS_RECORDING: "treatment.recording",
  SET_WORD_UUID: "treatment.articulationWordUUID",
  //speech
  SEND_S2T_RESULT: "treatment.nlp",
  SEND_RECORDINGS_COUNT: "treatment.nlpCount",
  SPEECH_CLEAR_STATE: "treatment.nlpStop",
  SPEECH_TOGGLE_ENABLE_RECORDING: "treatment.toggleEnableRecording",
  SPEECH_SEND_UUID: "treatment.speechUUID",

  //vocabulary
  SET_MY_STUDENT_VOCAB_GAME: "treatment.setMyStudentVocabGame",

  REQUEST_CURRENT_CONTENT: "treatment.requestCurrentContent",
  
  WHITEBOARD_UPDATE: "whiteboard.update",
  WHITEBOARD_SAVE: "whiteboard.save",

  H5P_GAME_UPDATE: "treatment.H5PGameUpdate",
  H5P_GAME_PREVIEW_UPDATE: "treatment.H5PGamePreviewUpdate",
  H5P_RE_ASSIGN_CURRENT_GAME: "treatment.H5PReAssignCurrentGame",

  PUSH_STUDNET: "treatment.pust_student",

  //users
  UPDATE_USERS: "users_status_update",

  //video
  APPROVE_VIDEO: "treatment.video.approve",
  UPDATE_PARTICIPANTS: "treatment.video.updateParticipants",
  ASK_VIDEO_START: "treatment.video.askStart",
  VIDEO_START_OK: "treatment.video.startOk",
  VIDEO_ERROR: "treatment.video.error",
  VIDEO_TEACHER_START_OK: "treatment.video.startTeacherOk",
  TOGGLE_VIDEO_PAUSE: "treatment.video.toggleVideoPause",
  TOGGLE_TEACHER_VIDEO_PAUSE: "treatment.video.toggleTeacherVideoPause",
  TOGGLE_TEACHER_MUTE: "treatment.video.toggleTeacherMute",
  TOGGLE_MUTE: "treatment.video.toggleMute",
  TOGGLE_STUDENT_MUTE: "treatment.video.toggleStudentMute",
  TOGGLE_STUDENT_PAUSE: "treatment.video.toggleStudentPause",
  TOGGLE_STUDENT_MUTE_BY_TEACHER: "treatment.video.toggleStudentMuteByTeacher",
  TOGGLE_STUDENT_PAUSE_BY_TEACHER: "treatment.video.toggleStudentPauseByTeacher",
  TOGGLE_STUDENT_MUTE_BY_STUDENT: "treatment.video.toggleStudentMuteByStudent",
  TOGGLE_STUDENT_PAUSE_BY_STUDENT: "treatment.video.toggleStudentPauseByStudent",
  VIDEO_KICK_STUDENT: "treatment.video.kickStudent",
  STUDENT_DISAPPROVED_VIDEO: "treatment.video.studentDisapprovedVideo",
  VIDEO_RESET_STUDENT: "treatment.video.videoResetStudent",
  ASK_TO_JOIN_VIDEO: "treatment.video.askToJoinVideo",



  SET_YOUTUBE_VIDEO_ID: "treatment.setYoutubeVideoId",
  IS_YOUTUBE_PLAYING: "treatment.isYoutubePlying",
  YOUTUBE_SKIPPED_TIME: "treatment.youtubeSkippedTime",
  IS_ENDED_YOUTUBE_VIDEO: "treatment.isEndedYoutubeVideo",
  IS_ERROR_YOUTUBE_VIDEO: "treatment.isErrorYoutubeVideo",
  // Reading
  READING_GENERIC_SEND: "reading.readingGenericSend",
  READING_SEND_STATUS: "reading.readingSendStatus",
  READING_CLEAR_STATE: "reading.readingClearState",
  
  // Spelling
  SPELLING_GENERIC_SEND: "spelling.spellingGenericSend",
  SPELLING_SEND_STATUS: "spelling.spellingSendStatus",
  SPELLING_SEND_PREVIEW_STATUS: "spelling.spellingSendPreviewStatus",

  //CHAT
  CHAT_NEW_MESSAGE: "treatment.chat.new_message",
  CHAT_GET_MESSAGE_LIST: "treatment.chat.get_message_list",
  CHAT_WIDGET_OPENED: "treatment.chat.chat_widget_opened",
  
  //Tech stats
  TECH_INIT_STATUS: "treatment.tech.init_status",
  TECH_INIT_ERRORS: "treatment.tech.init_errors",
  TECH_VIDEO_PERMISSIONS: "treatment.tech.video_permissions",
  TECH_AUDIO_PERMISSIONS: "treatment.tech.audio_permissions",
  TECH_WINDOW_FOCUS_STATUS: "treatment.tech.window_focus_status",
  TECH_WINDOW_VISIBILITY_STATUS: "treatment.tech.window_visibility_status",
  TECH_OPENTOK_ERROR: "treatment.tech.opentok_error",
  // TECH_INIT_ERRORS: "treatment.tech.init_errors",
  TECH_ASSIGN_ACTIVITY: "treatment.tech.assign_activity",
  TECH_RECEIVE_ACTIVITY: "treatment.tech.receive_activity",
};
